module.exports = __webpack_public_path__ + "img/x.c4e90a4d.svg";